/* Meyer & Hässig homepage interactions for Shopify Impact 7.x */
(function () {
  'use strict';

  var initializedSliders = new WeakSet();
  var initializedScrollAreas = new WeakSet();

  function setupSlider(slider) {
    if (!slider || initializedSliders.has(slider)) return;

    var slides = Array.prototype.slice.call(slider.querySelectorAll('[data-mh-slide]'));
    var dots = Array.prototype.slice.call(slider.querySelectorAll('[data-mh-dot]'));
    var previous = slider.querySelector('[data-mh-previous]');
    var next = slider.querySelector('[data-mh-next]');
    var currentIndex = 0;
    var timer = null;
    var autoplay = slider.getAttribute('data-autoplay') === 'true';
    var autoplaySeconds = parseInt(slider.getAttribute('data-autoplay-seconds'), 10) || 6;

    if (slides.length === 0) return;

    function normalize(index) {
      return (index + slides.length) % slides.length;
    }

    function show(index, focusSlide) {
      currentIndex = normalize(index);

      slides.forEach(function (slide, slideIndex) {
        var isActive = slideIndex === currentIndex;
        slide.classList.toggle('is-active', isActive);
        slide.setAttribute('aria-hidden', isActive ? 'false' : 'true');
        slide.setAttribute('tabindex', isActive ? '0' : '-1');
      });

      dots.forEach(function (dot, dotIndex) {
        var isActive = dotIndex === currentIndex;
        dot.classList.toggle('is-active', isActive);
        dot.setAttribute('aria-current', isActive ? 'true' : 'false');
      });

      if (focusSlide) slides[currentIndex].focus({ preventScroll: true });
    }

    function stopAutoplay() {
      if (timer) window.clearInterval(timer);
      timer = null;
    }

    function startAutoplay() {
      stopAutoplay();
      if (!autoplay || slides.length < 2 || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      timer = window.setInterval(function () {
        show(currentIndex + 1, false);
      }, autoplaySeconds * 1000);
    }

    if (previous) {
      previous.addEventListener('click', function () {
        show(currentIndex - 1, false);
        startAutoplay();
      });
    }

    if (next) {
      next.addEventListener('click', function () {
        show(currentIndex + 1, false);
        startAutoplay();
      });
    }

    dots.forEach(function (dot, dotIndex) {
      dot.addEventListener('click', function () {
        show(dotIndex, false);
        startAutoplay();
      });
    });

    slider.addEventListener('mouseenter', stopAutoplay);
    slider.addEventListener('mouseleave', startAutoplay);
    slider.addEventListener('focusin', stopAutoplay);
    slider.addEventListener('focusout', startAutoplay);

    slider.addEventListener('keydown', function (event) {
      if (event.key === 'ArrowLeft') {
        event.preventDefault();
        show(currentIndex - 1, true);
      }
      if (event.key === 'ArrowRight') {
        event.preventDefault();
        show(currentIndex + 1, true);
      }
    });

    slider._mhShowSlide = show;
    initializedSliders.add(slider);
    show(0, false);
    startAutoplay();
  }

  function setupScrollArea(section) {
    if (!section || initializedScrollAreas.has(section)) return;

    var track = section.querySelector('[data-mh-scroll-track]');
    var controls = Array.prototype.slice.call(section.querySelectorAll('[data-mh-scroll]'));
    if (!track || controls.length === 0) return;

    controls.forEach(function (control) {
      control.addEventListener('click', function () {
        var direction = control.getAttribute('data-mh-scroll') === 'previous' ? -1 : 1;
        var card = track.firstElementChild;
        var gap = parseFloat(window.getComputedStyle(track).columnGap || window.getComputedStyle(track).gap) || 16;
        var distance = card ? card.getBoundingClientRect().width + gap : track.clientWidth * 0.8;
        track.scrollBy({ left: direction * distance, behavior: 'smooth' });
      });
    });

    initializedScrollAreas.add(section);
  }

  function init(root) {
    var scope = root || document;

    if (scope.matches && scope.matches('[data-mh-slider]')) setupSlider(scope);
    Array.prototype.forEach.call(scope.querySelectorAll('[data-mh-slider]'), setupSlider);

    if (scope.matches && scope.matches('[data-mh-scroll-section]')) setupScrollArea(scope);
    Array.prototype.forEach.call(scope.querySelectorAll('[data-mh-scroll-section]'), setupScrollArea);
  }

  function onReady() {
    init(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', onReady, { once: true });
  } else {
    onReady();
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });

  document.addEventListener('shopify:block:select', function (event) {
    var blockId = event.detail && event.detail.blockId;
    if (!blockId) return;

    var section = event.target;
    var slide = section.querySelector('[data-block-id="' + blockId + '"]');
    if (!slide) return;

    var slider = slide.closest('[data-mh-slider]');
    if (!slider || typeof slider._mhShowSlide !== 'function') return;

    var slides = Array.prototype.slice.call(slider.querySelectorAll('[data-mh-slide]'));
    var index = slides.indexOf(slide);
    if (index >= 0) slider._mhShowSlide(index, false);
  });

  window.MHHomepage = { init: init };
})();
